import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import ColumnsOptions from './components/_edit-options';
import Column from './components/column';
import { getColClass } from './utils';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('columns', {
  template: require('./template.html'),
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeDropletItem',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'bouncePluginHook',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    profile() {
      return this._dropletType(this.droplet);
    },
    hideTransform() {
      return this.globalToolBarOpen ||
      this.globalBubbleOptionsOpen ||
      this.dragging ||
      (this.globalBubbleOpen && !this.showEditBubble);
    },
    getTransformStyle() {
      let style = null;
      if (this.globalToolBarOpen) {
        style = 'initial';
      }
      if (!this.globalBubbleOpen && this.display.perspective) {
        style = 'preserve-3d';
      }
      return style;
    },
    setClass() {
      return getColClass(this.droplet.columns.length);
    },
    drp() {
      return this.droplet;
    },
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', > .column' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
    lastRowMargin() {
      const selector = _.find(this.droplet.mediaQueries, {
        selector: dropletSchema.lastRowSelector,
      });
      const property = selector ? _.find(selector.properties, { property: 'margin-bottom' }) : false;
      return property;
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        transform: null,
        perspective: null,
        top: null,
        bottom: null,
        left: null,
        right: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        'padding-left': null,
        'padding-right: ': null,
        'padding-top:': null,
        'padding-bottom': null,
        'margin-bottom': null,
        'box-shadow': null,
        'border-top-width': null,
        'border-bottom-width': null,
        'border-left-width': null,
        'border-right-width': null,
        'border-top-right-radius': null,
        'border-top-left-radius': null,
        'border-bottom-right-radius': null,
        'border-bottom-left-radius': null,
      },
      hidden: false,
      dropletHovered: false,
      setBubbleSize: 'dropletBubble-normal',
      showEditBubble: false,
      hasActiveChild: false,
      showRevealClass: false,
      activeColumn: null,
    };
  },
  name: 'columns',
  props: ['block-index', 'droplet', 'items', 'index', 'canvas'],
  components: {
    DropletOptions,
    ColumnsOptions,
    Column,
    tooltip,
  },
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '> .column',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
      if (this.droplet.equalHeights) {
        // we need to give the dom little
        // buffer before bouncing plugin
        setTimeout(() => {
          this.unBindPlugin();
          this.bindPlugin();
        }, 500);
      }
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    'activeDroplet._id': function checkDroplets(id) {
      if (id && this.droplet._id !== id) {
        const activeDroplets = this.$el.querySelectorAll(`#drp-${id}`);
        if (activeDroplets.length > 0) {
          this.hasActiveChild = true;
        }
      } else {
        this.hasActiveChild = false;
      }
      if (!id) {
        this.showRevealClass = false;
      }
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    bouncePluginHook(id) {
      if (this.droplet._id === id) {
        this.$store.dispatch('callPluginBounce', false);
        if (this.droplet.equalHeights) {
          this.unBindPlugin();
          this.bindPlugin();
        }
      }
    },
  },
  created() {
    this.checkNewValues();
  },
  mounted() {
    this.callCssGenerator();
    this.observeVisibility();
    if (this.droplet.equalHeights) {
      this.unBindPlugin();
      this.bindPlugin();
    }
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drps: [...this.droplet.columns, this.droplet],
      });
    },
    checkNewValues() {
      if (!this.lastRowMargin) {
        this.$store.dispatch('changeDropletCss', {
          drp: this.droplet,
          val: '0px',
          property: 'margin-bottom',
          selector: dropletSchema.lastRowSelector,
          viewport: this.viewport,
        });
        this.callCssGenerator();
      }
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    bindPlugin() {
      const $columns = $(this.$refs.dropletRow);
      $columns.equalHeights();
    },
    unBindPlugin() {
      const $columns = $(this.$refs.dropletRow);
      if (!_.isUndefined($columns.equalHeights.destroy)) {
        $columns.equalHeights.destroy($columns);
      }
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    getDisplayShadow(_id) {
      const activeColumn = this.activeDropletItem;
      return (activeColumn && activeColumn._id === _id) || !activeColumn || !activeColumn._id;
    },
    setActiveLink(column) {
      this.activeColumn = column;
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/columns/index.js